module.exports = __webpack_public_path__ + "static/media/18.V-Funnel.d71303ff.webp";